// extracted by mini-css-extract-plugin
export var component = "Breadcrumbs-module--component--yH-ui";
export var description = "Breadcrumbs-module--description--oL3ef";
export var item = "Breadcrumbs-module--item--RVEdT";
export var link = "Breadcrumbs-module--link--rI6eQ";
export var list = "Breadcrumbs-module--list--J+UYe";
export var separator = "Breadcrumbs-module--separator--UQSHX";
export var sronly = "Breadcrumbs-module--sronly--7xtjv";